export default __webpack_public_path__ + "static/media/spainFlag.a28b1eb8.webp";